export default {
	/**
	 * Requests an email be sent with a password reset link.
	 * @param {string} email The email to send the reset link.
	 * @returns {Promise}
	 */
	async requestReset (email) {},

	/**
	 * Resets the provided user's password.
	 *
	 * @param {string} email The user's email
	 * @param {string} token The password reset token
	 * @param {string} password The new password
	 * @param {string} passwordConfirmation The same new password for confirmation
	 * @returns {Promise}
	 */
	async resetPassword (email, token, password, passwordConfirmation) {}
};
